import { useCallback } from 'react';
import { useApp } from '../providers/AppProvider';

export const useTranslation = () => {
    const { localisations } = useApp();

    return useCallback(
        (key: string) => {
            return localisations?.[key] ?? key;
        },
        [localisations],
    );
};
